import {
  ArrowBack,
  ArrowForward,
  Clear,
  Close,
  Search,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { GridSearchIcon } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import dayjs from "dayjs";
import { useFormik } from "formik";
import React, { useState } from "react";
import { toast } from "react-toastify";
// import FlightDetails from "./FlightDetails";
import TestSelection from "../../../components/Pathology_comp/PathologyPatientRegistration/TestSelection";
import InputMask from "react-input-mask";
import { useNavigate } from "react-router-dom";
interface PathologyPatientRegistrationProps {
  closeAllScreen: () => void;
  paramsId?: string;
}
const validationSchema = Yup.object().shape({
  mrn: Yup.number(),
  patientName: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Patient Name should contain only alphabets")
    .required("Patient Name is required"),
  guardiansName: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Guardian's Name should contain only alphabets")
    .required("Guardian's Name is required"),

  gender: Yup.string().required("Gender is required"),
  dob: Yup.string()
    .required("Date is required")
    .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format"),
  phonNumber: Yup.string()
    .required("Phone number is required")
    .transform(value => (value ? value.replace(/-/g, "") : value))
    .matches(/^03\d{9}$/, "Phone number must start with 03"),
  cnic: Yup.string()
    // .required("CNIC is required")
    .transform((value, originalValue) => {
      // Remove hyphens and spaces from the CNIC number
      return originalValue
        ? originalValue.replace(/[-\s]/g, "")
        : originalValue;
    })
    .test("is-length", "CNIC must be exactly 13 characters long", value => {
      return value ? value.length === 13 : true;
    }),
  healthId: Yup.string().optional(),
  city: Yup.string().matches(/^[^\d]+$/, "City should not contain numbers"),
  // .required("City is required"),
  reference: Yup.string(),
  searchCNIC: Yup.string(),
  searchName: Yup.string(),
});
const AccountPatientRegistration: React.FC<
  PathologyPatientRegistrationProps
> = ({ closeAllScreen, paramsId }) => {
  const [searchValue, setSearchValue] = useState("");
  const [storeData, setStoreData] = useState({
    mrn: 0,
    patientName: "",
    guardiansName: "",
    gender: "",
    dob: dayjs().format("YYYY-MM-DD"),
    phonNumber: "",
    cnic: "",
    healthId: "",
    city: "",
    reference: "",
    searchCNIC: "",
  });
  const [formChanged, setFormChanged] = useState(false);
  const [age, setAge] = useState<any>("");
  const [selectedId, setSelectedId] = useState(paramsId ? paramsId : "");
  const [selectedMRN, setSelectedMRN] = useState<number | null>(null);
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [discard, setDiscard] = useState(false);
  const handleOpen = () => {
    setOpenDeleteModal(true);
  };
  const navigate = useNavigate();
  const handleClose = () => {
    setOpenDeleteModal(false);
  };
  const confirmDelete = () => {
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LAB_URL}/patient-registration/deletePatientById/${selectedId}`,
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    axios
      .request(config)
      .then(response => {
        if (response?.data?.isSuccess) {
          setStoreData({
            mrn: 0,
            patientName: "",
            guardiansName: "",
            gender: "",
            dob: dayjs().format("YYYY-MM-DD"),
            phonNumber: "",
            cnic: "",
            healthId: "",
            city: "",
            reference: "",
            searchCNIC: "",
          });
          setSelectedId("");
          setSelectedMRN(0);
          toast.success(response?.data?.message);
          closeAllScreen();
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch(error => {})
      .finally(() => {
        setOpenDeleteModal(false);
      });
  };
  const [openTestSelection, setOpenTestSelection] = useState(
    paramsId ? true : false
  );
  const formik = useFormik({
    initialValues: storeData,
    validationSchema,
    onSubmit: values => {
      if (selectedId) {
        let updateData = {
          patientName: values?.patientName,
          guardiansName: values?.guardiansName,
          gender: values?.gender,
          dob: values?.dob,
          phonNumber: values?.phonNumber,
          cnic: values?.cnic,
          helthId: values?.healthId,
          city: values?.city,
          reference: values?.reference,
          extra: {},
        };
        axios
          .put(
            `${process.env.REACT_APP_LAB_URL}/patient-registration/updatePatient/${selectedId}`,
            updateData,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then(response => {
            setStoreData(response?.data?.data);
            if (response?.data?.isSuccess) {
              toast.success(response?.data?.message);
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch(error => {
            console.error("Error sending PUT request:", error);
          });
      } else {
        let data = {
          patientName: values?.patientName,
          guardiansName: values?.guardiansName,
          gender: values?.gender,
          dob: values?.dob,
          phonNumber: values?.phonNumber,
          cnic: values?.cnic,
          helthId: values?.healthId,
          city: values?.city,
          reference: values?.reference,
        };

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_ADMIN_API_URL}/patient-registration/registerPatient`,
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          data: data,
        };

        axios
          .request(config)
          .then(response => {
            let responseData = response?.data;
            if (responseData?.isSuccess) {
              setDiscard(true);
              toast.success(responseData?.message);
              setStoreData(responseData?.data);
              navigate("/account/income", {
                state: { patient: responseData?.data },
              });

              //   setSelectedId(responseData?.data?._id);
              closeAllScreen();
              setSelectedMRN(responseData?.data?.mrn);
            } else {
              toast.error(responseData?.message);
            }
          })
          .catch(error => {});
      }
    },
  });
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // setSearchErrors(null);
    const { name, value } = event.target;

    // Removing hyphens from the CNIC input value
    const newValue = value.replace(/-/g, "");

    if (name && newValue) {
      // Check if the input is CNIC
      if (name === "cnic") {
        // Split CNIC into parts
        const cnicParts = newValue.match(/^(\d{5})(\d{7})(\d{1})$/);

        if (cnicParts) {
          // Join CNIC parts without hyphens
          const formattedCNIC = cnicParts.slice(1).join("");

          // Set formatted CNIC value

          formik.setFieldValue(name, formattedCNIC);
          formik.handleChange(event);
        } else {
          // If the input doesn't match the CNIC pattern, set the value without hyphens
          formik.setFieldValue(name, event.target.value);

          formik.handleChange(event);
        }
      } else if (name === "phonNumber") {
        const phoneNum = newValue.match(/^03\d{9}$/);
        formik.setErrors({ phonNumber: "Invalid phone number!" });
        if (phoneNum) {
          // Join CNIC parts without hyphens
          const formattedPhone = phoneNum.slice(1).join("");

          // Set formatted CNIC value
          formik.setFieldValue(name, formattedPhone);
          formik.handleChange(event);
        } else {
          // If the input doesn't match the CNIC pattern, set the value without hyphens
          formik.setFieldValue(name, newValue);
          formik.handleChange(event);
        }
      } else {
        // For other inputs, set the value directly
        formik.setFieldValue(name, newValue);
        formik.handleChange(event);
      }

      // Handle additional form changes
    } else {
      // Clear the field if the value is empty
      formik.setFieldValue(name, "");
      formik.handleChange(event);
    }
  };

  const handleSearch = () => {
    setDiscard(false);
    setSelectedId("");
    // Define API endpoint based on searchType
    let endpoint = `getPatientByMRN/${searchValue}`;

    // Perform API call
    fetch(
      `${process.env.REACT_APP_PATHOLOGY_URL}/patient-registration/${endpoint}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Network response was not ok");
        }
      })
      .then(data => {
        // Handle API response data
        const patients = data?.data;
        const patientId = patients?._id;
        setSelectedId(patientId);

        if (patients) {
          toast.success("Record Found");
          setSelectedId(patients?._id);

          let convertDOB = DateOfBirthToAge(patients?.dob);
          setAge(convertDOB);
          setSearchValue("");
        }
        if (!patients) {
          toast.error("Record not Found");
        }
        if (!data?.isSuccess) {
          toast.error("Record not Found");
        }

        formik.setValues(patients);

        setStoreData(patients);
        const patientGuardianNames = patients.map((item: any) => ({
          patientName: item.patientName,
          guardiansName: item.guardiansName,
          mrn: item.mrn,
        }));
        // setModalData(patientGuardianNames);
        // handleOpenModal();
        // formik.setValues({ ...formik.values });
        // formik.setValues(patients);
      })
      .catch(error => {
        // Handle errors
        console.error("Error fetching data:", error);
        // toast.error('Record Not Found',error.message);
      });
  };
  const calculateAge = (birthDate: string | null) => {
    if (!birthDate) return null;

    const today = new Date();
    const dob = new Date(birthDate);

    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();

    if (months < 0 || (months === 0 && today.getDate() < dob.getDate())) {
      years--;
      months += 12;
    }

    return { years, months };
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  const closeTestSelectionPage = () => {
    setOpenTestSelection(false);
  };
  const DateOfBirthToAge = (dob: string): string => {
    const dobDate = new Date(dob);
    const currentDate = new Date();

    let years = currentDate.getFullYear() - dobDate.getFullYear();
    let months = currentDate.getMonth() - dobDate.getMonth();
    let days = currentDate.getDate() - dobDate.getDate();

    if (months < 0 || (months === 0 && days < 0)) {
      years--;
      months += 12;
    }

    if (days < 0) {
      const prevMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        dobDate.getDate()
      );
      const diff =
        (currentDate.getTime() - prevMonth.getTime()) / (1000 * 60 * 60 * 24);
      days = Math.floor(diff);
    }

    const age = `${years.toString().padStart(2, "0")}-${months
      .toString()
      .padStart(2, "0")}-${days.toString().padStart(2, "0")}`;
    return age;
  };
  const handleChangeAge = (e: React.ChangeEvent<HTMLInputElement>) => {
    const parts: any = e.target.value.split("-");
    let year = parts[0] > 99 ? "00" : parts[0];
    let month = parts[1] > 12 ? "00" : parts[1];
    let day = parts[2] > 99 ? "00" : parts[2];

    // Reconstruct the corrected value
    const correctedValue = `${year}-${month}-${day}`;
    setAge(correctedValue);
    let age = calculateDateOfBirth(correctedValue);
    formik.setFieldValue("dob", age);
  };
  const calculateDateOfBirth = (age: string): string => {
    const [years, months, days] = age.split("-").map(Number);

    // Get current date
    const currentDate = new Date();

    // Subtract age from current date
    const dateOfBirth = new Date(
      currentDate.getFullYear() - years,
      currentDate.getMonth() - months,
      currentDate.getDate() - days
    );

    // Format date of birth
    const dobString = `${dateOfBirth.getFullYear()}-${(
      dateOfBirth.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${dateOfBirth.getDate().toString().padStart(2, "0")}`;

    return dobString;
  };
  return openTestSelection ? (
    <TestSelection
      patientId={selectedId}
      pageClose={closeTestSelectionPage}
      closeAllScreen={closeAllScreen}
    />
  ) : (
    <div>
      <Box sx={{ background: "#fff", borderRadius: "12px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            sx={{
              color: "#000",
              fontSize: "16px",
              fontWeight: "600",
              textTransform: "capitalize",
            }}
          >
            Patient Registation
          </Typography>
          <Close sx={{ cursor: "pointer" }} onClick={closeAllScreen} />
        </Box>
      </Box>

      <Box sx={{ background: "#fff", p: 2, mb: 2, borderRadius: "12px" }}>
        <Box mt={2}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3} className="items-end justify-between">
              <Grid
                md={12}
                sm={12}
                xs={12}
                lg={4}
                sx={{ mt: { sm: 3, xs: 3, md: 3 } }}
              >
                <Dialog open={openDeleteModal} onClose={handleClose}>
                  <DialogTitle>Confirm Delete</DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      Are you sure you want to delete this item? This action
                      cannot be undone.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="error">
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>

            <Box mt={2}>
              <Grid container spacing={3}>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Patient Name :
                  </Typography>
                  <TextField
                    placeholder="Patient Name"
                    name="patientName"
                    fullWidth
                    size="small"
                    onChange={handleInputChange}
                    value={formik?.values?.patientName}
                    error={
                      formik?.touched?.patientName &&
                      Boolean(formik?.errors?.patientName)
                    }
                    FormHelperTextProps={{
                      sx: { fontSize: "10px" },
                    }}
                    helperText={
                      formik?.touched?.patientName &&
                      formik?.errors?.patientName
                    }
                    className="custom-input"
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Guardian Name :
                  </Typography>
                  <TextField
                    placeholder="Guardian Name"
                    name="guardiansName"
                    fullWidth
                    onChange={handleInputChange}
                    size="small"
                    value={formik?.values?.guardiansName}
                    error={
                      formik?.touched?.guardiansName &&
                      Boolean(formik?.errors?.guardiansName)
                    }
                    FormHelperTextProps={{
                      sx: { fontSize: "10px" },
                    }}
                    helperText={
                      formik?.touched?.guardiansName &&
                      formik?.errors?.guardiansName
                    }
                    className="custom-input"
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Gender :
                  </Typography>
                  <RadioGroup
                    name="gender"
                    row
                    onChange={handleInputChange}
                    value={formik?.values?.gender}
                  >
                    <FormControlLabel
                      value="Male"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "13px",
                            },
                          }}
                        />
                      }
                      label="Male"
                    />
                    <FormControlLabel
                      value="Female"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "13px",
                            },
                          }}
                        />
                      }
                      label="Female"
                    />
                    <FormControlLabel
                      value="Other"
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "13px",
                            },
                          }}
                        />
                      }
                      label="Other"
                    />
                  </RadioGroup>
                  {formik.touched.gender && formik.errors.gender && (
                    <Typography variant="caption" color="error" fontSize={10}>
                      {formik?.errors?.gender}
                    </Typography>
                  )}
                </Grid>
                <Grid item md={1.7} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Date of Birth:
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        formik?.values?.dob
                          ? dayjs(formik?.values?.dob)
                          : dayjs()
                      }
                      onChange={date => {
                        if (date) {
                          const formattedDate =
                            dayjs(date).format("YYYY-MM-DD");
                          formik.setFieldValue("dob", formattedDate);

                          let convertDOB = DateOfBirthToAge(formattedDate);
                          setAge(convertDOB);
                        } else {
                          formik.setFieldValue("dob", "");
                        }
                      }}
                      format="DD/MM/YYYY"
                      openTo="year"
                      maxDate={dayjs()}
                      views={["year", "month", "day"]}
                      sx={{
                        "& fieldset": {
                          // Target the fieldset for better border control
                          border: "none", // Remove default border if present
                        },
                        "& .MuiInputBase-root": {
                          height: "30px",
                          fontSize: "12px",
                          overflow: "hidden",
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          border: "none",
                          backgroundColor: "#F5F5FB",
                        },
                        "& .MuiCalendarPicker-root": {
                          overflow: "hidden",
                        },
                        "& .css-4jnixx-MuiStack-root": {
                          paddingTop: "0px",
                        },
                      }}
                    />
                  </LocalizationProvider>
                  {formik.touched.dob && formik.errors.dob && (
                    <Typography variant="caption" color="error" fontSize={10}>
                      {formik.errors.dob}
                    </Typography>
                  )}
                </Grid>
                <Grid item md={1.3} xs={12} sm={1.5}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    YY-MM-DD:
                  </Typography>
                  <InputMask
                    mask="99-99-99"
                    value={
                      age ? age : DateOfBirthToAge(dayjs().format("YYYY-MM-DD"))
                    }
                    onChange={handleChangeAge}
                    maskChar=" "
                  >
                    {
                      //@ts-ignore
                      () => (
                        <TextField
                          className="custom-input"
                          fullWidth
                          placeholder="YY-MM-DD"
                          size="small"
                        />
                      )
                    }
                  </InputMask>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Phone Number :
                  </Typography>
                  <InputMask
                    mask="9999-9999999"
                    value={formik?.values?.phonNumber}
                    onChange={handleInputChange}
                    maskChar=" "
                  >
                    {
                      //@ts-ignore
                      () => (
                        <TextField
                          placeholder="Phone Number"
                          name="phonNumber"
                          fullWidth
                          size="small"
                          className="custom-input"
                          error={
                            formik?.touched?.phonNumber &&
                            Boolean(formik?.errors?.phonNumber)
                          }
                          FormHelperTextProps={{
                            sx: { fontSize: "10px" },
                          }}
                          helperText={
                            formik?.touched?.phonNumber &&
                            formik?.errors?.phonNumber
                          }
                        />
                      )
                    }
                  </InputMask>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    CNIC :
                  </Typography>
                  <InputMask
                    mask="99999-9999999-9"
                    onChange={handleInputChange}
                    value={formik?.values?.cnic}
                    maskChar=" "
                  >
                    {
                      //@ts-ignore
                      () => (
                        <TextField
                          placeholder="CNIC"
                          name="cnic"
                          fullWidth
                          size="small"
                          className="custom-input"
                          error={
                            formik.touched.cnic && Boolean(formik.errors.cnic)
                          }
                          FormHelperTextProps={{
                            sx: { fontSize: "10px" },
                          }}
                          helperText={formik.touched.cnic && formik.errors.cnic}
                        />
                      )
                    }
                  </InputMask>
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Health Id :
                  </Typography>
                  <TextField
                    placeholder="Health Id"
                    name="healthId"
                    fullWidth
                    onChange={handleInputChange}
                    size="small"
                    className="custom-input"
                    value={formik?.values?.healthId}
                    error={
                      formik?.touched?.healthId &&
                      Boolean(formik.errors.healthId)
                    }
                    FormHelperTextProps={{
                      sx: { fontSize: "10px" },
                    }}
                    helperText={
                      formik.touched.healthId && formik.errors.healthId
                    }
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    City :
                  </Typography>
                  <TextField
                    placeholder="City"
                    name="city"
                    fullWidth
                    onChange={handleInputChange}
                    value={formik?.values?.city}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    FormHelperTextProps={{
                      sx: { fontSize: "10px" },
                    }}
                    helperText={formik.touched.city && formik.errors.city}
                    size="small"
                    className="custom-input"
                  />
                </Grid>
                <Grid item md={3} sm={6} xs={12}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: "#000",
                      fontWeight: "700",
                    }}
                  >
                    Refference (optional) :
                  </Typography>
                  <TextField
                    placeholder="Refference"
                    name="reference"
                    fullWidth
                    onChange={handleInputChange}
                    value={formik?.values?.reference}
                    size="small"
                    className="custom-input"
                  />
                </Grid>
              </Grid>
            </Box>
              <Box display="flex" justifyContent="end" mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{ padding: "2px" }}
                >
                  Submit
                </Button>
              </Box>
          </form>
        </Box>
      </Box>
    </div>
  );
};

export default AccountPatientRegistration;
